'use client';

import React from 'react';
import {UseFilters} from './useFilters';

export interface FiltersContextProps {
	control: UseFilters<any, any>;
}

export const FiltersContext = React.createContext<FiltersContextProps | null>(null);
